'use strict';

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getJobStartTime = function getJobStartTime(job) {
  return job.modules && job.modules.date && job.modules.date.time && job.modules.date.time.startTime;
};

var getJobPartialOrder = function getJobPartialOrder(job, partialOrder) {
  return partialOrder && partialOrder[job.id] && partialOrder[job.id].order;
};

/**
 * Compares two jobs based on their date module and current partial order.
 * 
 * Criteria is:
 * 
 * - If both jobs have time, partialOrder doesn't matter, we just compare their startTime.
 * - If none of them have time assigned (all day jobs), check the partial order.
 *    - If both are in the partial order, return the order defined there.
 *    - If none of them are in the partial order, return the order as the key (job ID).
 *    - If one of them is in the partial order and the other not, place the one not in the partial order before.
 * - If one of `a` or `b` has time and the other doesn't, then:
 *    - If both are in the partial order, return the order defined there.
 *    - If none of them are in the partial order, all day jobs comes before timed jobs.
 *    - One is in the partial order, the other isn't, then:
 *      - If the all day job is the one not in the partial order, then this job comes before.
 *      - If the timed event is the one not in the partial order, we need to check the original
 *        order of cards according to the current partial order.
 */
var _compare = function _compare(a, b, partialOrder, list) {
  var aStartTime = getJobStartTime(a);
  var bStartTime = getJobStartTime(b);
  // Both jobs have time.
  if (aStartTime && bStartTime) {
    return aStartTime.localeCompare(bStartTime);
  }
  // Both jobs are all day.
  if (!aStartTime && !bStartTime) {
    var _apo = getJobPartialOrder(a, partialOrder);
    var _bpo = getJobPartialOrder(b, partialOrder);
    // If both jobs have a partial order defined, return that order.
    if (_apo && _bpo) {
      return _apo - _bpo;
    }
    // If none of them have a partial order defined, compare them by key (job ID).
    if (!_apo && !_bpo) {
      return a.id.localeCompare(b.id);
    }
    // Otherwise, place the one not in the partial order before.
    return _bpo ? -1 : 1;
  }
  // One of `a` or `b` has time and the other doesn't.
  var apo = getJobPartialOrder(a, partialOrder);
  var bpo = getJobPartialOrder(b, partialOrder);
  // If both are in the partial order, return the order defined there.
  if (apo && bpo) {
    return apo - bpo;
  }
  // If none of them are in the partial order, all day jobs comes before timed jobs.
  if (!apo && !bpo) {
    return bStartTime ? -1 : 1;
  }
  // One is in the partial order, the other isn't:
  // If the all day job is the one not in the partial order, then this job comes before.
  if (!aStartTime && !apo) {
    return -1;
  }
  if (!bStartTime && !bpo) {
    return 1;
  }
  // Make `a` the job with time and not in the partial order, for the sake of a simpler implementation.
  // swaping `a` and `b` would get us to this point again with the necessary condition above.
  if (bStartTime && !bpo) {
    return -1 * _compare(b, a, partialOrder, list);
  }
  // At this point we have a timed job `a` not in the partial order and an all day job `b` that is in the partial order.
  // We need to look at this partial order and the relation of `b` with the other timed jobs.
  // If there is a timed job `c` before `b` w/ time `a` < `c`, then, by transitivity, `a` < `c` < `b`, otherwise, `a` > `b`.
  for (var j = 0; j < _lodash2.default.size(list); j++) {
    var c = list[j];
    if (c !== a && c !== b) {
      var cpo = getJobPartialOrder(c, partialOrder);
      if (cpo && cpo < bpo) {
        var cStartTime = getJobStartTime(c);
        if (cStartTime && aStartTime.localeCompare(cStartTime) < 0) {
          return -1;
        }
      }
    }
  }
  return 1;
};

/**
 * Finds the index of the minimum element of the list in the range list[start, length).
 */
var findMin = function findMin(list, start, partialOrder) {
  var minIndex = start;
  for (var j = start + 1; j < _lodash2.default.size(list); j++) {
    if (_compare(list[j], list[minIndex], partialOrder, list) < 0) {
      minIndex = j;
    }
  }
  return minIndex;
};

var swap = function swap(list, j, k) {
  if (j !== k) {
    var temp = list[j];
    list[j] = list[k];
    list[k] = temp;
  }
};

var nextMinSort = function nextMinSort(list, partialOrder) {
  for (var j = 0; j < _lodash2.default.size(list); j++) {
    var indexOfMin = findMin(list, j, partialOrder);
    swap(list, j, indexOfMin);
  }
};

var JobsUtils = {

  compare: function compare(a, b, partialOrder, list) {
    return _compare(a, b, partialOrder, list);
  },

  /**
   * Sort a list of jobs (events).
   * 
   * Each instance in the jobs array contains a date module. The job can be of two types:
   * - timed (has time assigned)
   * - all day (do not has time assigned)
   * 
   * partialOrder argument is a partial ordering of the jobs. Each instance in this object has the ID of
   * a job as its key and an order (number) property.
   * 
   * Returns an array with the IDs of the jobs sorted according to the criteria above.
   */
  sort: function sort(jobs, partialOrder) {
    if (!jobs || _lodash2.default.size(jobs) < 2) {
      return jobs;
    }
    var result = jobs.slice();
    nextMinSort(result, partialOrder);
    return result;
  }

};

module.exports = JobsUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/JobsUtils.js
// module id = 1043
// module chunks = 0